import { useFretboardConfigStore } from '@/features/fretboard-base';
import React from 'react';

interface HeightRatioSelectorProps {
  minHeightRatio?: number;
  maxHeightRatio?: number;
  step?: number;
  label?: string;
}

export const HeightRatioSelector: React.FC<HeightRatioSelectorProps> = ({
  minHeightRatio = 0.15,
  maxHeightRatio = 1,
  step = 0.01,
  label = 'Fretboard Height',
}) => {
  const heightRatio = useFretboardConfigStore((state) => state.heightRatio);
  const setHeightRatio = useFretboardConfigStore((state) => state.setHeightRatio);

  // Convert the decimal ratio to percentage for UI
  const heightPercentage = Math.round(heightRatio * 100);

  // Min and max as percentages
  const minPercent = Math.round(minHeightRatio * 100);
  const maxPercent = Math.round(maxHeightRatio * 100);
  const stepPercent = Math.round(step * 100);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPercentage = parseInt(e.target.value, 10);
    if (!isNaN(newPercentage)) {
      // Convert percentage back to decimal for the store
      const newRatio = newPercentage / 100;
      setHeightRatio(Math.max(minHeightRatio, Math.min(maxHeightRatio, newRatio)));
    }
  };

  return (
    <div className="form-control w-full mb-3 max-w-full">
      <label className="label">
        <span className="label-text">{label}</span>
        <span className="label-text-alt">{heightPercentage}% of screen</span>
      </label>
      <div className="flex gap-3 items-center">
        <input
          type="range"
          className="range range-primary flex-grow"
          value={heightPercentage}
          onChange={handleChange}
          min={minPercent}
          max={maxPercent}
          step={stepPercent || 1}
        />
        <input
          type="number"
          className="input input-bordered input-sm w-20 min-w-18"
          value={heightPercentage}
          onChange={handleChange}
          min={minPercent}
          max={maxPercent}
          step={stepPercent || 1}
        />
      </div>
    </div>
  );
};
